<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <!-- <h2>Select a date and click done below</h2>

    <div class="ui segment" *ngFor="let item of history">
        <div fxLayout="row">
            
        </div>
    </div> -->

    <form class="ui form">
      <div class="grouped fields">
        <label> Select a date and click on the View button below </label>
        <div
          class="field"
          *ngFor="let item of history"
          appMargin
          marginB="20px"
        >
          <div class="ui segment">
            <div fxLayout="row">
              <div fxFlex>
                <sui-radio-button
                  name="timer"
                  [value]="item.id"
                ></sui-radio-button>
              </div>
              <div fxLayout="row">
                <div fxLayout="column">
                  <h2>{{ item.dateCreated | date: "medium" }}</h2>
                  <div fxLayout="row">
                    <div>{{ item.user }}</div>
                    <div>{{ item.user }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="actions" style="background: transparent; border: none">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Close
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="pending"
    (click)="submit()"
    autofocus
  >
    View
  </button>
</div>
